<template>
  <div class="astroCalendarParm">
    <TabSecondary
      :tabList="filterOptionList"
      :currentValue="currentFitler"
      @change="($event) => (currentFitler = $event)"
    ></TabSecondary>

    <div class="astroCalendarParm__listBox">
      <div class="astroCalendarParm__listBox__row header">
        <div class="astroCalendarParm__listBox__cell">发生事件</div>
        <div class="astroCalendarParm__listBox__cell">时间</div>
      </div>
      <div
        class="astroCalendarParm__listBox__row"
        v-for="event in currentMonthEventsFiltered"
        :key="event.id"
      >
        <div class="astroCalendarParm__listBox__cell">{{ event.title }}</div>
        <div class="astroCalendarParm__listBox__cell">{{ event.start }}
          <br v-if="event.end !== event.start" />
          <span v-if="event.end !== event.start"> ~ {{ event.end }}</span>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import TabSecondary from "@/components/UI/TabSecondary.vue";

export default {
  components: {
    TabSecondary,
  },
  props: {
    filterOptionList: {
      type: Array,
      default: () => [],
    },
    currentMonthEventsAll: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentFitler: "進入星座",
    };
  },
  computed: {
    currentMonthEventsFiltered() {
      return this.currentMonthEventsAll.filter((event) => {
        return event.calendarId === this.currentFitler;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/scss/_mixin.scss";

.astroCalendarParm {
  @include mobile{
    padding: 0 24px;
  }
  &__listBox {
    margin-top: 32px;
    border-collapse: collapse;
    width: 100%;
    height: auto;
    background-color: transparent;
    border-radius: 20px;
    box-shadow: -2px -2px 8px 0 rgba(238, 109, 175, 0.22), -4px -4px 12px 0 rgba(238, 109, 175, 0.22),
      4px 4px 20px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  &__listBox__row {
    display: flex;
    border-bottom: 1px solid #adadad;
    text-align: center;
  }

  &__listBox__cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 54px;
    color: $secondary-color-3;
    font-size: 16px;
    &:nth-of-type(1) {
      width: 40%;
      background-color: #241a3c;
    }
    &:nth-of-type(2) {
      width: 60%;
      background-color: #1b132d;
    }
    @include mobile{
      font-size: 14px;
    }
  }

  &__listBox__row.header &__listBox__cell {
    color: $theme-color-1;
    font-size: 16px;
    font-weight: 700;
    height: 58px;
  }

  //   &__listBox__row:not(.header) &__listBox__cell {
  //     height: 65px;
  //     background-color: #214c73;
  //     color: #fff;
  //     font-size: 18px;
  //     line-height: 2;
  //     &:nth-of-type(1) {
  //       border-right: 1px solid #adadad;
  //     }
  //   }
}
</style>
